import { Component, Input } from "@angular/core";
import { BulkListingSearchFilter } from "src/app/shared/interfaces/bulk-listing-search-filter";

@Component({
	selector: "app-search-filter",
	templateUrl: "./search-filter.component.html",
	styleUrls: ["./search-filter.component.scss"],
})
export class SearchFilterComponent {
	@Input() searchFilter: BulkListingSearchFilter;
	@Input() expand: boolean;

	constructor() {}
}
